import { render } from "./MakeDonationWidget.vue?vue&type=template&id=3aa640a4"
import script from "./MakeDonationWidget.vue?vue&type=script&lang=js"
export * from "./MakeDonationWidget.vue?vue&type=script&lang=js"

import "./MakeDonationWidget.vue?vue&type=style&index=0&id=3aa640a4&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__